export default __webpack_public_path__ + "static/0232-330806fd71f48b8695038bd2494c3548.png";